import { apiClient } from './client'

/**
 * Create a Stripe Checkout session via the backend.
 *
 * @param {Object} payload
 * @param {'recurring' | 'gift'} payload.type
 * @param {string[]} [payload.subscriptionIds] — recurring tier slugs (supports duplicates)
 * @param {string} [payload.subscriptionId] — legacy single tier slug
 * @param {Object} [payload.preferences] — per-tier preferences, keyed by slug
 * @param {Array} [payload.items] — gift items
 */
export async function createOrder(payload) {
  return apiClient('/orders', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
